import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Formats raw school identifiers to Title Case words
// e.g., "poveda" -> "Poveda", "la_salle-green hills" -> "La Salle Green Hills"
export const formatSchoolName = (value: string | null | undefined): string => {
  if (!value) return "";
  const cleaned = value.replace(/[\s_-]+/g, " ");
  return cleaned
    .trim()
    .split(" ")
    .map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ""))
    .join(" ");
};
